import { useEffect, useState } from "react";
import { Menu, X, Phone, Star } from "lucide-react";
import { NAV_LINKS, phoneTel } from "../../lib/constants";
import { useSettings } from "../../lib/SettingsContext";
import { scrollToId } from "../../lib/lenis";

export const Navbar = () => {
  const s = useSettings();
  const phone = s.phone_display;
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled || open ? "bg-black/90 backdrop-blur-md border-b border-yellow-400/20" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <button data-testid="nav-logo" onClick={() => go("home")} className="flex items-center gap-2">
          <span className="w-9 h-9 rounded-lg bg-yellow-400 flex items-center justify-center rotate-3 shrink-0">
            <Star className="w-5 h-5 text-black" fill="currentColor" />
          </span>
          <span className="font-display font-bold text-lg sm:text-xl text-white whitespace-nowrap">
            بنشر متنقل <span className="text-yellow-400">نجم الإطارات</span>
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-6">
          {NAV_LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-sm text-zinc-300 hover:text-yellow-400 transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            data-testid="nav-call-btn"
            href={phoneTel(phone)}
            className="hidden sm:flex items-center gap-2 bg-yellow-400 text-black font-bold text-sm px-4 py-2 rounded-full hover:bg-yellow-300 transition-colors"
          >
            <Phone className="w-4 h-4" />
            <span dir="ltr">{phone}</span>
          </a>
          <button
            data-testid="nav-menu-btn"
            onClick={() => setOpen(!open)}
            className="lg:hidden text-white p-2"
            aria-label="القائمة"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="lg:hidden border-t border-yellow-400/10 bg-black/95 backdrop-blur-md px-6 py-4 flex flex-col gap-3"
        >
          {NAV_LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-mobile-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-right text-zinc-200 py-1.5 hover:text-yellow-400 transition-colors"
            >
              {l.label}
            </button>
          ))}
          <a
            data-testid="nav-mobile-call-btn"
            href={phoneTel(phone)}
            className="flex items-center justify-center gap-2 bg-yellow-400 text-black font-bold text-sm px-4 py-2.5 rounded-full mt-2"
          >
            <Phone className="w-4 h-4" />
            <span dir="ltr">{phone}</span>
          </a>
        </div>
      )}
    </header>
  );
};
